import React, { RefObject, useEffect, useState } from 'react'
import useAnimate from './useAnimate'
import cx from 'classnames'

export const FocusOverlay: React.FC<{
  elementRef: RefObject<HTMLElement>
  visible: boolean
  onClick: () => void
  offsetPx: number
  heightPx: number
}> = (props) => {
  const [focus, setFocus] = useState(false)
  const { className, style } = useAnimate({
    durationMs: 200,
    fromClasses: 'opacity-0',
    toClasses: 'opacity-100',
    show: focus || props.visible,
  })

  const offset = `-${props.offsetPx}px`

  const onFocus = () => {
    setFocus(true)
  }

  const onBlur = () => {
    setFocus(false)
  }

  useEffect(() => {
    if (!props.elementRef.current) return

    props.elementRef.current?.querySelector('input')?.addEventListener('focus', onFocus)
    props.elementRef.current?.querySelector('input')?.addEventListener('blur', onBlur)

    return () => {
      props.elementRef.current?.querySelector('input')?.removeEventListener('focus', onFocus)
      props.elementRef.current?.querySelector('input')?.removeEventListener('blur', onBlur)
    }
  }, [props.elementRef])

  return (
    <>
      <div
        className="flex-grow text-14 bg-transparent outline-none px-16 placeholder-dark placeholder-focus-hide relative"
        style={{ height: `${props.heightPx}px` }}
        onClick={() => setFocus(false)}
      />
      <div
        onClick={props.onClick}
        className={cx('fixed top-0 left-0 bottom-0 right-0', className)}
        style={{ ...style, background: 'rgba(0, 0, 0, 0.4)', zIndex: 17, pointerEvents: 'none' }}
      />
      <div
        className={cx('bg-white absolute', className)}
        style={{
          ...style,
          left: offset,
          right: offset,
          zIndex: 18,
          top: offset,
          bottom: offset,
        }}
      />
    </>
  )
}
